import { customEvent } from "goi_common";

interface DirectionsHeroProps {
  companyName: string;
  sidoName: string;
  sigunguName: string;
  address: string;
  telephone: string;
}

export const DirectionsHero = ({
  companyName,
  sidoName,
  sigunguName,
  address,
  telephone,
}: DirectionsHeroProps) => {
  const regionLabel = `${sidoName} ${sigunguName}`;
  const heroLede = `${companyName}은 ${regionLabel}에 위치해 있습니다. 위치, 대중교통, 자가용, 주차 정보를 참고하여 방문에 도움이 되시기 바랍니다.`;

  return (
    <section className="dr-hero" aria-labelledby="dr-page-title">
      <div className="dr-hero__head">
        <div className="dr-hero__tags">
          <span className="dr-tag dr-tag--accent">찾아가시는 길</span>
        </div>

        <h1 id="dr-page-title" className="dr-hero__title">
          {`${companyName} 찾아가시는 길`}
        </h1>
        <p className="dr-hero__lede">{heroLede}</p>

        <table
          className="dr-info-table"
          aria-label={`${companyName} 기본 정보`}
        >
          <tbody>
            <tr>
              <th scope="row">장례식장명</th>
              <td>{companyName}</td>
            </tr>
            <tr>
              <th scope="row">주소</th>
              <td>{address}</td>
            </tr>
            {telephone && (
              <tr>
                <th scope="row">전화</th>
                <td className="dr-info-table__muted">
                  <a
                    href={`tel:${telephone}`}
                    className="dr-info-table__muted-link"
                    onClick={() =>
                      customEvent({
                        newGtm: {
                          path: "prlr_directions",
                          trigger_and_target: "btn_call",
                        },
                      })
                    }
                  >
                    {telephone}
                  </a>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};
